import React, { Component } from 'react'
import ProTypes from 'prop-types'
import { req_list_ccw_hotkeyword } from '../../api'

export default class Search extends Component {
    // 基礎通用參數 //////////////////////////////////////////////  
    static propTypes = {
        setSearchName: ProTypes.func.isRequired
    }
    state = {
        hotKeys: [],
        searchMessage: ''
    }

    componentDidMount = () => {
        // const hotKeys = [{ name: '獎學金', total: 20 }, { name: '補助', total: 10 }, { name: '租屋', total: 5 }]
        this.api_list_hotKeyword()
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_list_hotKeyword = async () => {
        const result = await req_list_ccw_hotkeyword()
        // console.log(result)
        if (result.total > 0) {
            const hotKeywords = result.data
            const rows = hotKeywords.map((item, index) => { return { name: item.SearchValue, total: item.SearchTotal } })
            this.setState({ hotKeys: rows })
        } else {
            const hotKeywords = []
            this.setState({ hotKeys: hotKeywords })
        }
    }

    serach_holder = () => {
        // 得到輸入的關鍵字
        const searchName = this.input.value.trim()
        const reg = /[`~!@#$%^&*()+=|{}':;',/.<>/?~！@#￥%……&*（）——+|{}【】‘；：”“’。，、？]/
        
        if (reg.test(searchName)) {
            const searchMessage = '內含特殊符號，請刪除重新輸入!'
            this.setState({ searchMessage })
        } else {
            // 搜尋
            if (searchName.length > 0) {
                this.props.setSearchName(searchName)
            } else {
                const searchMessage = '請輸入欲搜索之關鍵字!'
                this.setState({ searchMessage })
            }
        }
    }

    hotKey_handle = (key_name) => {
        const searchName = key_name
        this.input.value = key_name
        if (searchName) {
            this.props.setSearchName(searchName)
        }
    }

    ////////////////////////////////////////////////

    render() {
        const style = {
            fontSize: '16px',
        };
        const { hotKeys, searchMessage } = this.state

        return (
            <div className="container">
                <div className="jumbotron text-center">
                    <h2>您想看什麼作品呢?</h2>
                    <div className="input-group">
                        <input type="text" className="form-control" size="50" placeholder="請輸入關鍵字" ref={input => this.input = input} required />
                        <div className="input-group-btn">
                            <button type="button" className="btn btn-danger" onClick={this.serach_holder}><i className="fa fa-search" aria-hidden="true"></i> 查詢</button>
                        </div>
                    </div>
                    <div>{searchMessage === '' ? '' : (<span style={{ color: 'red' }}>{searchMessage}</span>)}</div>
                    &ensp;
                    <div className="row">
                        { hotKeys.length > 0 ? (<span style={style}>熱門關鍵字：</span>) : ''}
                        {
                            hotKeys.map((hotkey, index) => {
                                return (
                                    <div key={index} style={{margin: '1px'}}>
                                        <button type="button" className="btn btn-warning btn-sm" onClick={() => this.hotKey_handle(hotkey.name)}>
                                            {hotkey.name} <span className="badge badge-danger"> {hotkey.total}</span>
                                            <span className="sr-only">unread messages</span>
                                        </button>
                                        &ensp;
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        )
    }
}
